import { Box } from "@mui/material";

import { i18n } from "services/i18nService";

export function UpsTrademark() {
  return (
    <Box sx={{ display: "flex", gap: 1, alignItems: "center", mt: 2 }}>
      <div>
        <img
          src="/images/ups_logo_small.gif"
          alt="UPS logo small"
          style={{ width: "50px" }}
        />
      </div>
      <div>{i18n("upsShipment.UpsTrademarkDescription")}</div>
    </Box>
  );
}
